import { render, staticRenderFns } from "./PageSelectMenuSearch.vue?vue&type=template&id=63ec83e8"
import script from "./PageSelectMenuSearch.vue?vue&type=script&lang=js"
export * from "./PageSelectMenuSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports